import PropTypes from 'prop-types'
import { useState } from 'react'
import { TYPE_CUSTOMER_PRODUCT, TYPE_MESSAGE_GROUP, TYPE_USER } from '../constants/avatar'
import { Pencil } from '../icons'
import Avatar from './Avatar'

function EditableAvatar({
  avatarType,
  avatarId,
  onClick,
  cacheBust,

}) {
  const [isHovering, setIsHovering] = useState(false)
  return (
    <button
      type="button"
      className="relative flex w-[60px] h-[60px] mr-4 cursor-pointer"
      onClick={onClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <Avatar className="absolute w-[60px] h-[60px]" type={avatarType} id={avatarId} cacheBust={cacheBust} />
      {
        isHovering && (
          <Pencil className="absolute rounded-full p-4 w-[60px] h-[60px] text-white text-[24px]
            pointer-events-none bg-black bg-opacity-60"
          />
        )
      }
    </button>
  )
}

EditableAvatar.propTypes = {
  avatarType: PropTypes.oneOf([TYPE_CUSTOMER_PRODUCT, TYPE_MESSAGE_GROUP, TYPE_USER]),
  avatarId: PropTypes.string,
  onClick: PropTypes.func,
  cacheBust: PropTypes.number,
}

EditableAvatar.defaultProps = {
  avatarType: null,
  avatarId: null,
  onClick: () => {
  },
  cacheBust: null,
}

export default EditableAvatar
